import React, { useEffect, useRef, useState } from "react";

const Steps = () => {

   
     return (
        <>
        <section className="registration_steps step my-52">
          <div className="container-sm">

          
            <h5 className="text-center">
                Easy step to expand your business
            </h5>
            <div className="row row-cols-1 row-cols-md-3 justify-content-center justify-content-md-between my-52 mx-auto" style={{maxWidth:"1200px"}}>
                <div>
                    <div style={{width:"144px", height:"144px"}} className=' flex-center stepnumber_outer rounded-circle order-0 mx-auto'>
                      <h4 style={{width:"90px", height:"90px"}} className='mb-0 stepnumber_bginner text-white d-flex align-items-center justify-content-center rounded-circle border border-5 border-white fw-medium'>
                        01
                      </h4>
                    </div>
                    <div className="text-center my-20">
                      <div>
                        <span className="fw-bold text-black " style={{fontSize:"24px"}}>
                          Create an account
                        </span>
                      </div>
                      <div>
                        <span className=" " style={{fontSize:"16px"}}>
                          Complete document needed.
                        </span>
                      </div>
                    </div>
                </div>
                <div>
                    <div style={{width:"144px", height:"144px"}} className=' flex-center stepnumber_outer rounded-circle order-0 mx-auto'>
                      <h4 style={{width:"90px", height:"90px"}} className='mb-0 stepnumber_bginner text-white d-flex align-items-center justify-content-center rounded-circle border border-5 border-white fw-medium'>
                        02
                      </h4>
                    </div>
                    <div className="text-center my-20">
                      <div>
                        <span className="fw-bold text-black " style={{fontSize:"24px"}}>
                          Wait for verification
                        </span>
                      </div>
                      <div>
                        <span className=" " style={{fontSize:"16px"}}>
                          We'll verify your document.
                        </span>
                      </div>
                    </div>
                </div>
                <div>
                    <div style={{width:"144px", height:"144px"}} className=' flex-center stepnumber_outer rounded-circle order-0 mx-auto'>
                      <h4 style={{width:"90px", height:"90px"}} className='mb-0 stepnumber_bginner text-white d-flex align-items-center justify-content-center rounded-circle border border-5 border-white fw-medium'>
                        03
                      </h4>
                    </div>
                    <div className="text-center my-20">
                      <div>
                        <span className="fw-bold text-black " style={{fontSize:"24px"}}>
                          Start selling
                        </span>
                      </div>
                      <div>
                        <span className=" " style={{fontSize:"16px"}}>
                          Upload your products and start selling.
                        </span>
                      </div>
                    </div>
                </div>
            </div>
          </div>
        </section>
        
        
        </>
     )
    }


    export default Steps;